/* Growth Automated theme — shared behaviour (self-contained, no dependencies) */
(function () {
  /* ---- Mobile nav drawer ---- */
  var mnav = document.getElementById('mnav');
  var btn = document.getElementById('menuBtn');
  if (mnav && btn) {
    var open = function () {
      mnav.classList.add('open');
      document.body.classList.add('mnav-open');
      mnav.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true');
    };
    var close = function () {
      mnav.classList.remove('open');
      document.body.classList.remove('mnav-open');
      mnav.setAttribute('aria-hidden', 'true');
      btn.setAttribute('aria-expanded', 'false');
    };
    btn.addEventListener('click', open);
    mnav.querySelectorAll('[data-mnav-close]').forEach(function (el) { el.addEventListener('click', close); });
    mnav.querySelectorAll('.mnav-links a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---- Carousel dot indicators (mobile) ---- */
  function buildDots(track) {
    var cards = [].slice.call(track.children);
    if (cards.length < 2) return;
    var dots = document.createElement('div');
    dots.className = 'cdots';
    cards.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to item ' + (i + 1));
      b.addEventListener('click', function () {
        var left = track.scrollLeft + (c.getBoundingClientRect().left - track.getBoundingClientRect().left) - 24;
        track.scrollTo({ left: left, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });
    track.parentNode.insertBefore(dots, track.nextSibling);
    function update() {
      var tl = track.getBoundingClientRect().left, best = 0, bestD = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.getBoundingClientRect().left - tl - 24);
        if (d < bestD) { bestD = d; best = i; }
      });
      [].forEach.call(dots.children, function (d, i) { d.classList.toggle('active', i === best); });
    }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    update();
  }
  document.querySelectorAll('[data-carousel]').forEach(buildDots);
})();


/* ============================================================
   Restored interactive modules (modals, lightbox, galleries)
   — were inline <script> in the HTML mockups; consolidated here.
   Each is a self-contained IIFE that no-ops if its markup is absent.
   ============================================================ */

/* --- homepage --- */
(function(){
/* Bad Dog venture gallery — dots + gentle auto-advance */
(function(){
  var track=document.getElementById('bd-track');
  var dotsBox=document.getElementById('bd-dots');
  if(!track||!dotsBox) return;
  var slides=[].slice.call(track.children);
  if(slides.length<2) return;
  slides.forEach(function(_,i){
    var b=document.createElement('button');
    b.type='button'; b.setAttribute('aria-label','Show artwork '+(i+1)+' of '+slides.length);
    b.addEventListener('click',function(){goTo(i,true);});
    dotsBox.appendChild(b);
  });
  function slideWidth(){return slides[0].getBoundingClientRect().width + 14;}
  function currentIndex(){
    var w=slideWidth();
    return Math.round(track.scrollLeft/w);
  }
  function goTo(i,userInteraction){
    if(userInteraction) pauseAuto();
    var w=slideWidth();
    track.scrollTo({left:i*w,behavior:'smooth'});
  }
  function update(){
    var i=currentIndex();
    [].forEach.call(dotsBox.children,function(d,idx){d.classList.toggle('active',idx===i);});
  }
  var raf; track.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(update);},{passive:true});
  update();
  /* Auto-advance every 4.5s unless user interacts or prefers reduced motion */
  var prefersReduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var auto=null, paused=false;
  function tick(){
    if(paused) return;
    var i=(currentIndex()+1)%slides.length;
    goTo(i,false);
  }
  function pauseAuto(){paused=true;clearInterval(auto);setTimeout(function(){paused=false;},8000);}
  if(!prefersReduce){
    auto=setInterval(tick,4500);
    track.addEventListener('pointerenter',function(){paused=true;});
    track.addEventListener('pointerleave',function(){paused=false;});
    track.addEventListener('touchstart',pauseAuto,{passive:true});
  }
})();
})();

/* --- business --- */
(function(){
/* Trustpilot review modal open/close */
(function(){
  var openers=document.querySelectorAll('[data-tp-open]');
  var lastFocus=null;
  function openTp(id){
    var m=document.getElementById('tp-'+id);
    if(!m) return;
    lastFocus=document.activeElement;
    m.classList.add('open');
    document.body.classList.add('tp-open');
    m.setAttribute('aria-hidden','false');
    var closer=m.querySelector('.tp-close');
    if(closer) closer.focus();
  }
  function closeTp(){
    var open=document.querySelector('.tp.open');
    if(!open) return;
    open.classList.remove('open');
    document.body.classList.remove('tp-open');
    open.setAttribute('aria-hidden','true');
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  openers.forEach(function(a){
    a.addEventListener('click',function(e){e.preventDefault();openTp(a.getAttribute('data-tp-open'));});
  });
  document.querySelectorAll('[data-tp-close]').forEach(function(el){
    el.addEventListener('click',closeTp);
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeTp();});
})();
})();

/* --- business --- */
(function(){
/* LinkVault ICP modal open/close */
(function(){
  var lastFocus=null;
  function openLv(id){
    var m=document.getElementById('lv-'+id);
    if(!m) return;
    lastFocus=document.activeElement;
    m.classList.add('open');
    document.body.classList.add('lv-open');
    m.setAttribute('aria-hidden','false');
    var closer=m.querySelector('.lv-close');
    if(closer) closer.focus();
  }
  function closeLv(){
    var open=document.querySelector('.lv.open');
    if(!open) return;
    open.classList.remove('open');
    document.body.classList.remove('lv-open');
    open.setAttribute('aria-hidden','true');
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  document.querySelectorAll('[data-lv-open]').forEach(function(a){
    a.addEventListener('click',function(e){e.preventDefault();openLv(a.getAttribute('data-lv-open'));});
  });
  document.querySelectorAll('[data-lv-close]').forEach(function(el){
    el.addEventListener('click',closeLv);
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeLv();});
})();
})();

/* --- business --- */
(function(){
/* Grace plan modal open/close */
(function(){
  var lastFocus=null;
  function openGr(){
    var m=document.getElementById('gr-plan');
    if(!m) return;
    lastFocus=document.activeElement;
    m.classList.add('open');
    document.body.classList.add('gr-open');
    m.setAttribute('aria-hidden','false');
    var closer=m.querySelector('.gr-close');
    if(closer) closer.focus();
  }
  function closeGr(){
    var open=document.querySelector('.gr.open');
    if(!open) return;
    open.classList.remove('open');
    document.body.classList.remove('gr-open');
    open.setAttribute('aria-hidden','true');
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  document.querySelectorAll('[data-grace-open]').forEach(function(a){
    a.addEventListener('click',function(e){e.preventDefault();openGr();});
  });
  document.querySelectorAll('[data-gr-close]').forEach(function(el){
    el.addEventListener('click',closeGr);
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeGr();});
})();
})();

/* --- ai-agents --- */
(function(){
/* AGENT modal open/close */
(function(){
  var lastFocus=null;
  function openAg(id){
    var m=document.getElementById('ag-'+id);
    if(!m) return;
    lastFocus=document.activeElement;
    m.classList.add('open');
    document.body.classList.add('ag-open');
    m.setAttribute('aria-hidden','false');
    var closer=m.querySelector('.ag-close');
    if(closer) closer.focus();
  }
  function closeAg(){
    var open=document.querySelector('.ag.open');
    if(!open) return;
    open.classList.remove('open');
    document.body.classList.remove('ag-open');
    open.setAttribute('aria-hidden','true');
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  document.querySelectorAll('[data-ag-open]').forEach(function(a){
    a.addEventListener('click',function(e){e.preventDefault();openAg(a.getAttribute('data-ag-open'));});
  });
  document.querySelectorAll('[data-ag-close]').forEach(function(el){
    el.addEventListener('click',closeAg);
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAg();});
})();
})();

/* --- consumer --- */
(function(){
/* Facts of Life carousel — auto-advance, arrows, dots, pause on hover, respects reduced motion */
(function(){
  var stage=document.getElementById('folStage');
  var dotsWrap=document.getElementById('folDots');
  if(!stage||!dotsWrap) return;
  var slides=[].slice.call(stage.querySelectorAll('.fol-slide'));
  if(slides.length<2) return;
  var idx=0, timer=null, INTERVAL=3800;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  slides.forEach(function(_,i){
    var b=document.createElement('button');
    b.type='button'; b.className='fol-dot'+(i===0?' is-on':'');
    b.setAttribute('aria-label','Fact '+(i+1)+' of '+slides.length);
    b.addEventListener('click',function(){go(i,true);});
    dotsWrap.appendChild(b);
  });
  var dots=[].slice.call(dotsWrap.children);

  function go(n,user){
    idx=(n+slides.length)%slides.length;
    slides.forEach(function(s,i){s.classList.toggle('is-on',i===idx);});
    dots.forEach(function(d,i){d.classList.toggle('is-on',i===idx);});
    if(user) restart();
  }
  function next(){go(idx+1);}
  function prev(){go(idx-1);}
  function start(){ if(reduce) return; stop(); timer=setInterval(next,INTERVAL); }
  function stop(){ if(timer){clearInterval(timer); timer=null;} }
  function restart(){ stop(); start(); }

  var wrap=stage.closest('.fol-carousel')||stage.parentNode;
  wrap.addEventListener('mouseenter',stop);
  wrap.addEventListener('mouseleave',start);
  document.addEventListener('visibilitychange',function(){document.hidden?stop():start();});

  document.querySelectorAll('[data-fol]').forEach(function(btn){
    btn.addEventListener('click',function(){
      (btn.getAttribute('data-fol')==='next'?next:prev)();
      restart();
    });
  });

  // touch swipe
  var sx=null;
  stage.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
  stage.addEventListener('touchend',function(e){
    if(sx==null)return;
    var dx=e.changedTouches[0].clientX-sx; sx=null;
    if(Math.abs(dx)>30){ (dx<0?next:prev)(); restart(); }
  });

  start();
})();
})();

/* --- ecommerce --- */
(function(){
/* Portfolio lightbox open/close (Shoresy banner from Jeff Hersh quote) */
(function(){
  var openers=document.querySelectorAll('[data-lb-open]');
  var lastFocus=null;
  function openLb(id){
    var m=document.getElementById('lb-'+id); if(!m) return;
    lastFocus=document.activeElement;
    m.classList.add('open'); document.body.classList.add('lb-open');
    m.setAttribute('aria-hidden','false');
    var c=m.querySelector('.lb-close'); if(c)c.focus();
  }
  function closeLb(){
    var o=document.querySelector('.lb.open'); if(!o) return;
    o.classList.remove('open'); document.body.classList.remove('lb-open');
    o.setAttribute('aria-hidden','true');
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  openers.forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();openLb(a.getAttribute('data-lb-open'));});});
  document.querySelectorAll('[data-lb-close]').forEach(function(el){el.addEventListener('click',closeLb);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeLb();});
})();
})();
